export interface SpeechToTextRequest {
  audio: Blob;
  token: string;
  experienceId?: string;
  sessionId?: string;
  turnId?: string;
  contentType?: string;
  durationMs?: number;
  maxDurationSeconds?: number;
}

export interface SpeechToTextResult {
  text: string;
  transcriptId?: string;
  provider?: string;
  durationMs?: number;
  language?: string;
}

export interface SpeechToTextPort {
  transcribe(request: SpeechToTextRequest): Promise<SpeechToTextResult>;
}

/**
 * Classified transcription failures so the shell can show
 * participant-consequential copy instead of raw technical messages.
 * Classification is client-observed (HTTP status / fetch failure); it will
 * narrow further once Gaia ships typed provider errors (contract row C3).
 */
export type SpeechToTextErrorCode =
  | 'auth'
  | 'provider-unavailable'
  | 'malformed-response'
  | 'network'
  | 'unknown';

export class SpeechToTextError extends Error {
  constructor(
    public readonly code: SpeechToTextErrorCode,
    message: string
  ) {
    super(message);
    this.name = 'SpeechToTextError';
  }
}
